'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function intToDuration(seconds, highestOnly) {
    if (highestOnly === void 0) { highestOnly = false; }
    var duration = [];
    var add = function (unit, value) {
        if (value && (!highestOnly || (highestOnly && !duration.length))) {
            if (highestOnly && unit !== 'seconds') {
                duration.push(value + 1 + " " + unit);
            }
            else {
                duration.push(value + " " + unit);
            }
        }
    };
    add('years', Math.floor(seconds / 31536000));
    add('days', Math.floor((seconds % 31536000) / 86400));
    add('hours', Math.floor(((seconds % 31536000) % 86400) / 3600));
    add('minutes', Math.floor((((seconds % 31536000) % 86400) % 3600) / 60));
    add('seconds', (((seconds % 31536000) % 86400) % 3600) % 60);
    var last = duration.pop();
    if (!last) {
        return '';
    }
    if (duration.length) {
        return duration.slice(0, -1).join(', ') + " and " + last;
    }
    return last;
}
function intToDurationObject(seconds) {
    return {
        days: Math.floor((seconds % 31536000) / 86400),
        hours: Math.floor(((seconds % 31536000) % 86400) / 3600),
        minutes: Math.floor((((seconds % 31536000) % 86400) % 3600) / 60),
        seconds: Math.floor((((seconds % 31536000) % 86400) % 3600) % 60),
        years: Math.floor(seconds / 31536000),
    };
}

exports.default = intToDuration;
exports.intToDurationObject = intToDurationObject;
//# sourceMappingURL=int_to_duration.js.map
